import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { StarIcon } from 'lucide-react';
export function TestimonialsHero() {
  return <section className="bg-black pt-[180px] pb-[80px] lg:pt-[200px] lg:pb-[120px] relative overflow-hidden" data-id="element-2116">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10" data-id="element-2117">
        <AnimateOnScroll className="flex flex-col items-center text-center" data-id="element-2118">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-6 font-[Poppins,_sans-serif]" data-id="element-2119">
            TESTIMONIALS
          </span>

          <h1 className="text-[32px] sm:text-5xl md:text-6xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-2120">
            Patient Testimonials
          </h1>

          <p className="font-serif italic text-[17px] lg:text-[22px] text-white/85 leading-[1.6] mb-8 max-w-[600px] mx-auto" data-id="element-2121">
            Real results. Real patients. See why our clients love Be CLINICAL.
          </p>

          {/* Rating Badge */}
          <div className="flex items-center gap-3 mb-8" data-id="element-2122">
            <div className="flex gap-0.5" data-id="element-2123">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2124" />)}
            </div>
            <span className="text-white font-bold text-base font-[Poppins,_sans-serif]" data-id="element-2125">
              4.5 Rating
            </span>
            <span className="text-[#B0B0B0] text-base font-[Poppins,_sans-serif]" data-id="element-2126">
              250+ Reviews
            </span>
          </div>

          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto" data-id="element-2127"></div>
        </AnimateOnScroll>
      </div>
    </section>;
}